import { FlagCategory, FlagCategoryColor } from '@enums/service-request-flags.enum';

export function setCategoryColor(category: string): string {
    switch (category) {
      case FlagCategory.Customer:
        return FlagCategoryColor.Customer;
      case FlagCategory.Ground:
        return FlagCategoryColor.Ground;
      case FlagCategory.Air:
        return FlagCategoryColor.Air;
      case FlagCategory.SRInfo:
        return FlagCategoryColor.SRInfo;
      case FlagCategory.Documentation:
        return FlagCategoryColor.Documentation;
      case FlagCategory.Catering:
        return FlagCategoryColor.Catering;
      default:
        return 'black';
    }
  }